import { render, staticRenderFns } from "./8.vue?vue&type=template&id=df8bde0e&scoped=true&"
import script from "./8.vue?vue&type=script&lang=js&"
export * from "./8.vue?vue&type=script&lang=js&"
import style0 from "./8.vue?vue&type=style&index=0&id=df8bde0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8bde0e",
  null
  
)

export default component.exports